import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPeopleIdCard2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="people-id-card-2, profile, user-account, badge, person"><path d="M9.75 4.75H5L5 20.75H19V4.75H14.25" stroke="currentColor" strokeWidth="1.5"/><rect x="9.75" y="2.75" width="4.5" height="4.5" stroke="currentColor" strokeWidth="1.5"/><path d="M8 20.75C8 18.5409 9.79086 16.75 12 16.75C14.2091 16.75 16 18.5409 16 20.75" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12.25" r="2.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPeopleIdCard2;
